module.exports = __webpack_public_path__ + "img/20190715160302979.5b9e52b2.png";